module.exports = __webpack_public_path__ + "e86c83034df01d9b2033947ee4570306.svg";